import BannerAward2024 from '../img/banner/Award2024.png';
import Logo from '../img/event/2607/logo.png';
import Title from '../img/event/2607/title.png';
import FreeLectureImage from '../img/event/2607/free-lecture.png';
import BoostUpTitle from '../img/event/2607/boostup-title.png';
import BoostUpCircles from '../img/event/2607/circles.png';
import Text from '../img/event/2607/text.png';
import Online_Session from '../img/event/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import React from 'react';

const HomeschoolEvent202607 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#0EB6DD]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="flex flex-col gap-10 pt-8 sm:gap-20 sm:pt-20">
          <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
            {/* 젭스 영어교실 로고 */}
            <div className="mx-auto flex max-w-[100px] pb-4 sm:max-w-[150px] md:max-w-[180px]">
              <img src={Logo} alt="젭스 영어교실 로고" />
            </div>

            {/* 타이틀 섹션 */}
            <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
              {/* 타이틀 - 이미지 */}
              <div className="m-auto flex flex-col">
                <img
                  src={Title}
                  alt="여름방학 특강 준비 젭스영어교실과 함께 영어도 믿음도 BOOST-UP!"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      <div className="flex items-center justify-center">
        <div className="flex w-full flex-col bg-[#0EB6DD] px-5 py-10 sm:px-10 sm:py-14">
          {/* 상단 타이틀 */}
          <div className="flex flex-col items-center text-center">
            <p className="text-base font-bold leading-relaxed text-white sm:text-xl md:text-2xl">
              젭스영어교실로 실력 폭발!
            </p>

            <p className="mt-1 text-xl font-extrabold leading-tight text-[#FEF78F] sm:text-3xl md:text-4xl">
              효과 TOP3
            </p>
          </div>

          {/* TOP3 박스 */}
          <section className="mx-auto mt-5 flex w-full max-w-[300px] flex-col gap-4 sm:max-w-[400px] md:max-w-[500px]">
            <div className="flex min-h-[50px] items-center justify-center rounded-2xl border border-2 border-white px-4 py-5 text-center">
              <p className="text-sm font-bold leading-relaxed text-white sm:text-lg md:text-xl">
                청크 단위 학습으로 부담없이
                <span className="text-[#FEF78F]"> 1200문장 암송!</span>
              </p>
            </div>

            <div className="flex min-h-[50px] items-center justify-center rounded-2xl border border-2 border-white px-4 py-5 text-center">
              <p className="text-sm font-bold leading-relaxed text-white sm:text-lg md:text-xl">
                <span className="text-[#FEF78F]">48개의 성구와 스토리</span>로
                지루할 틈 없이!
              </p>
            </div>

            <div className="flex min-h-[50px] items-center justify-center rounded-2xl border border-2 border-white px-4 py-5 text-center">
              <p className="text-sm font-bold leading-relaxed text-white sm:text-lg md:text-xl">
                말하는 영문법으로
                <span className="text-[#FEF78F]">
                  &nbsp;스피킹과 문법을 한 번에!
                </span>
              </p>
            </div>
          </section>

          {/* 중간 이미지 + 겹침 영역 */}
          <div className="relative mx-auto mt-10 w-full max-w-[420px] pb-[150px]">
            {/* 위쪽 강조 문구: 이미지 상단에 걸치게 */}
            <div className="relative z-20 flex flex-col items-center text-center">
              <p className="text-xl font-bold leading-relaxed text-[#FEF78F] sm:text-2xl md:text-3xl">
                여기서 하나 더!
              </p>

              <p className="text-xl font-bold leading-relaxed text-[#FEF78F] sm:text-2xl md:text-3xl">
                학습 부스터 증정!
              </p>
            </div>

            {/* 원 + 무료강의 이미지 */}
            <div className="relative z-10 -mt-10">
              <img
                src={FreeLectureImage}
                alt="2개월 무료 강의"
                className="block w-full max-w-[500px]"
              />

              {/* 이미지 위 라벨 */}
              <div className="absolute left-1/2 top-[55%] z-20 -translate-x-1/2 text-center">
                <p className="text-sm font-bold leading-tight text-white sm:text-lg md:text-xl">
                  7월 등록 시,
                </p>

                <p className="mt-1 whitespace-nowrap bg-[#FEF78F] px-1 text-sm font-bold leading-tight text-[#0EB6DD] sm:text-lg md:text-xl">
                  추가 학습 강의 2개월 제공!
                </p>
              </div>

              {/* 하단 강의 카드: 이미지 아래쪽에 걸치게 */}
              <section className="absolute left-1/2 top-[75%] z-30 flex w-full max-w-[220px] -translate-x-1/2 flex-col gap-3 sm:max-w-[300px] md:max-w-[400px]">
                <div className="flex min-h-[70px] items-center justify-center rounded-2xl bg-white px-4 py-4 text-center sm:min-h-[80px] md:min-h-[90px]">
                  <p className="text-base font-bold leading-[1.4] text-black sm:text-lg md:text-xl">
                    영어의 기초를 잡는
                    <br />
                    <span className="font-extrabold text-[#0EB6DD]">
                      왕초보 파닉스
                    </span>
                  </p>
                </div>

                <div className="flex min-h-[70px] items-center justify-center rounded-2xl bg-white px-4 py-4 text-center sm:min-h-[80px] md:min-h-[90px]">
                  <p className="text-base font-bold leading-[1.4] text-black sm:text-lg md:text-xl">
                    영어 말하기 첫단계
                    <br />
                    <span className="font-extrabold text-[#0EB6DD]">
                      왕초보 패턴회화
                    </span>
                  </p>
                </div>

                <div className="flex min-h-[70px] items-center justify-center rounded-2xl bg-white px-4 py-4 text-center sm:min-h-[80px] md:min-h-[90px]">
                  <p className="text-base font-bold leading-[1.4] text-black sm:text-lg md:text-xl">
                    스피킹 집중 훈련
                    <br />
                    <span className="font-extrabold text-[#0EB6DD]">
                      스피드영어엔진
                    </span>
                  </p>
                </div>
              </section>
            </div>
          </div>

          {/* 하단 CTA */}
          <div className="mb-3 mt-16 flex flex-col items-center text-center">
            <p className="text-xl font-extrabold leading-relaxed text-white sm:text-2xl md:text-3xl">
              이 모든 강의를
            </p>

            <p className="text-xl font-extrabold leading-relaxed text-white sm:text-2xl md:text-3xl">
              <span className="text-[#FEF78F] underline decoration-[#FEF78F] underline-offset-4">
                두 달 동안
              </span>
              &nbsp;무료체험으로!
            </p>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#201A05]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720xpx] flex-col gap-10 px-5 py-10 sm:gap-20 sm:py-20">
          {/* 설명회 섹션 */}
          <div className="m-auto flex max-w-[480px] flex-col gap-5">
            {/* 타이틀 섹션 */}
            <section className="flex flex-col text-center sm:gap-1">
              {/* 서브타이틀 텍스트 */}
              <div className="text-xl font-semibold text-white sm:text-3xl">
                젭스영어교실로 실력 폭발!
              </div>
              {/* 타이틀 텍스트 */}
              <div className="text-3xl font-extrabold text-white sm:text-5xl">
                7월 온라인 설명회
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full">
              <img src={Online_Session} alt="젭스영어교실 온라인설명회" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/10"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                지금 온라인 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 4 */}
      <div className="flex items-center justify-center bg-gray2">
        <div className="m-auto flex w-full flex-col bg-[#FCF68F] px-5 py-10 sm:px-10 sm:py-14">
          {/* 상단 문구 */}
          <div className="flex flex-col items-center text-center">
            <p className="text-xl font-extrabold leading-tight text-[#0EB6DD] sm:text-3xl md:text-5xl">
              영어도 믿음도
            </p>

            {/* BOOST-UP 이미지 */}
            <div className="mt-1 w-full max-w-[200px] sm:max-w-[300px] md:max-w-[400px]">
              <img
                src={BoostUpTitle}
                alt="BOOST-UP!"
                className="block w-full"
              />
            </div>

            <div className="mt-2 bg-[#0EB6DD] px-2">
              <p className="text-xs font-extrabold leading-none text-[#FCF68F] sm:text-lg md:text-2xl">
                지금! 해야 하는 이유 3가지
              </p>
            </div>
          </div>

          {/* 원 3개 이미지 */}
          <div className="mx-auto mt-8 w-full max-w-[280px] sm:mt-10 sm:max-w-[500px] md:max-w-[580px]">
            <img
              src={BoostUpCircles}
              alt="쫄스 영어파닉스와 영어 학습 이유"
              className="block w-full"
            />
          </div>

          {/* 하단 박스 */}
          <section className="mx-auto mt-8 grid w-full max-w-[320px] grid-cols-[1.6fr_1fr] gap-2 sm:mt-10 sm:max-w-[550px] sm:gap-3 md:max-w-[600px]">
            <div className="flex min-h-[82px] items-center justify-center rounded-lg bg-[#DFF3A5] px-3 py-4 text-center sm:min-h-[150px] sm:px-5">
              <p className="text-xs leading-relaxed text-black sm:text-xl">
                우리 아이부터
                <br />
                하나님의 말씀으로 올바르게
                <br />
                영어 공부 시켜보고 싶어요!
              </p>
            </div>

            <div className="flex min-h-[82px] items-center justify-center rounded-lg bg-[#DFF3A5] px-3 py-4 text-center sm:min-h-[150px]">
              <p className="text-md font-extrabold leading-tight text-[#0EB6DD] sm:text-3xl">
                가정에서!
              </p>
            </div>

            <div className="flex min-h-[82px] items-center justify-center rounded-lg bg-[#DFF3A5] px-3 py-4 text-center sm:min-h-[150px] sm:px-5">
              <p className="text-xs leading-relaxed text-black sm:text-xl">
                우리 아이 뿐만 아니라
                <br />
                다음 세대를 품어보고 싶어요!
              </p>
            </div>

            <div className="flex min-h-[82px] items-center justify-center rounded-lg bg-[#DFF3A5] px-3 py-4 text-center sm:min-h-[150px]">
              <p className="text-md font-extrabold leading-tight text-[#0EB6DD] sm:text-3xl">
                공부방,
                <br />
                교습소에서!
              </p>
            </div>
          </section>
        </div>
      </div>

      {/* 프로모션 섹션 5 */}
      <div className="flex items-center justify-center bg-[#FCF68F]">
        <div className="m-auto flex w-full max-w-[720px] flex-col px-5 py-10 sm:px-10 sm:py-16">
          {/* 타이틀 */}
          <p className="text-center text-lg font-extrabold leading-relaxed text-black sm:text-xl md:text-2xl">
            누구든지 언제 어디서나
            <br />
            만나볼 수 있는 젭스 영어교실!
          </p>

          <div className="mx-auto flex max-w-[280px] pt-4 sm:max-w-[330px] md:max-w-[400px]">
            <img src={Text} alt="완벽한 영어학습법" />
          </div>

          {/* 버튼 */}
          <div className="mt-9 sm:mt-14">
            <DoubleLineWithCursorButton
              onClick={() => {
                window.open('https://jebs.kr/shop/details/NKyRTHjIgiewcumT');
              }}
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/70"
              textColor="text-white"
            >
              <div className="px-5 py-3 text-base font-bold sm:px-8 sm:py-5 sm:text-2xl md:text-4xl">
                7월 젭스영어교실&nbsp;
                <span className="text-[#FDF4B4]">등록하고 혜택 받기</span>
              </div>
            </DoubleLineWithCursorButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202607;
